// Reac Component
import React from 'react'
import { TFunction } from 'i18next';


// App Component
//import { env } from '../../services/app.conf'
import { FamlaServices } from '../../services'
import './UsersLogin.css'


interface iprops {
    t: TFunction;
}
const ButtonSocialeNetwork = (props: iprops) => {
    const { t } = props
    const [spinner, setSpinner] = React.useState(false);

    const navigateToNetwork = async (network: string) => {
        if (network === "apple") {
            // url = env['signin_with_apple']
        }
        else if (network === "google") {
            try {
                setSpinner(true)
                const data = await FamlaServices("api_host", "/google/login", "GET", "", "")
                const redirectUrl = data.body?.data
                if (data.status === 200 && redirectUrl) {
                    window.location.assign(redirectUrl);
                    return;
                }
                setSpinner(false)
            } catch (error) {
                console.error('[Google SSO] Unable to start login', error);
                setSpinner(false)
            }
        }
        else {
            // url = env['signin_with_microsoft']
        }
    }

    return (
        <div>
            <button
                type="button"
                className="btn auth-sso-login-btn auth-google-login-btn w-100 mt-3 d-flex align-items-center justify-content-center"
                onClick={() => navigateToNetwork('google')}
                disabled={spinner}
            >
                {spinner ? (
                    <div className="spinner-border spinner-border-sm text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                ) : (
                    <>
                        <svg viewBox="0 0 48 48" aria-hidden="true" focusable="false">
                            <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                            <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                            <path fill="#FBBC05" d="M10.53 28.59A14.43 14.43 0 0 1 9.75 24c0-1.59.28-3.14.78-4.59l-7.98-6.19A23.87 23.87 0 0 0 0 24c0 3.85.92 7.48 2.56 10.78l7.97-6.19z" />
                            <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                        </svg>
                        <span className="fw-bold">{t('views.auth.continueWithGoogle')}</span>
                    </>
                )}
            </button>
            {/* <Buttons
                name={t('views.auth.continueWithMicrosoft')}
                onClick={() => navigateToNetwork('microsoft')}
                isLoading={false}
                btnClass="btn-light w-100 mt-2"
                labelClass=""
                styleProps={{ height: 45 }}
                withIcon={true}
                iconName="fa-brands fa-microsoft"
                arrowVisible={false}
                arrowColor=''
            /> */}
            {/* <Buttons
                name={t('views.auth.continueWithApple')}
                onClick={() => navigateToNetwork('apple')}
                isLoading={false}
                btnClass="btn-light w-100 mt-2"
                labelClass=""
                styleProps={{ height: 45 }}
                withIcon={true}
                iconName="fa-brands fa-apple"
                arrowVisible={false}
                arrowColor=''
            /> */}
        </div>
    )
}

export default ButtonSocialeNetwork;